<template>
  <div class="pwa-test">
    <div class="pwa-test__container">
      <h1>PWA Test Page</h1>
      <p>Эта страница для тестирования PWA функциональности</p>
      
      <div class="pwa-test__status">
        <h2>Статус PWA</h2>
        <div class="pwa-test__item">
          <strong>Service Worker:</strong>
          <span :class="swStatus ? 'status-ok' : 'status-error'">
            {{ swStatus ? 'Активен' : 'Не активен' }}
          </span>
        </div>
        <div class="pwa-test__item">
          <strong>Manifest:</strong>
          <span :class="manifestStatus ? 'status-ok' : 'status-error'">
            {{ manifestStatus ? 'Загружен' : 'Не загружен' }}
          </span>
        </div>
        <div class="pwa-test__item">
          <strong>Install Prompt:</strong>
          <span :class="installPromptStatus ? 'status-ok' : 'status-warning'">
            {{ installPromptStatus ? 'Доступен' : 'Не доступен' }}
          </span>
        </div>
        <div class="pwa-test__item">
          <strong>Offline:</strong>
          <span :class="offlineStatus ? 'status-ok' : 'status-warning'">
            {{ offlineStatus ? 'Поддерживается' : 'Не поддерживается' }}
          </span>
        </div>
      </div>

      <div class="pwa-test__actions">
        <button
          class="pwa-test__btn"
          @click="testInstallPrompt"
        >
          Показать Install Prompt
        </button>
        <button
          class="pwa-test__btn"
          @click="testNotification"
        >
          Тест уведомлений
        </button>
        <button
          class="pwa-test__btn"
          @click="testOffline"
        >
          Тест Offline
        </button>
      </div>

      <div class="pwa-test__info">
        <h3>Инструкции по тестированию:</h3>
        <ol>
          <li>Откройте DevTools (F12) → Application → Manifest</li>
          <li>Проверьте Service Workers в DevTools</li>
          <li>Попробуйте установить приложение</li>
          <li>Протестируйте offline режим</li>
        </ol>
      </div>
    </div>
  </div>
</template>

<script>
export default {
    name: "PWATest",
    data() {
        return {
            swStatus: false,
            manifestStatus: false,
            installPromptStatus: false,
            offlineStatus: false,
        };
    },
    mounted() {
        this.checkPWAStatus();
    },
    methods: {
        checkPWAStatus() {
            // Check Service Worker
            if ("serviceWorker" in navigator) {
                navigator.serviceWorker.getRegistration().then((registration) => {
                    this.swStatus = !!registration;
                });
            }

            // Check Manifest
            const manifestLink = document.querySelector("link[rel=\"manifest\"]");
            this.manifestStatus = !!manifestLink;

            // Check Install Prompt
            this.installPromptStatus = "beforeinstallprompt" in window;

            // Check Offline support
            this.offlineStatus = "serviceWorker" in navigator && "caches" in window;
        },
        testInstallPrompt() {
            // Trigger install prompt manually
            const event = new Event("beforeinstallprompt");
            // Add mock prompt method for testing
            event.prompt = () => {
                console.log("Mock install prompt triggered");
                return Promise.resolve({ outcome: "accepted" });
            };
            event.userChoice = Promise.resolve({ outcome: "accepted" });
            window.dispatchEvent(event);
        },
        async testNotification() {
            if ("Notification" in window) {
                const permission = await Notification.requestPermission();
                if (permission === "granted") {
                    new Notification("PWA Test", {
                        body: "Уведомления работают!",
                        icon: "/img/icons/android-chrome-192x192.png",
                    });
                }
            }
        },
        testOffline() {
            if ("serviceWorker" in navigator) {
                navigator.serviceWorker.ready.then((registration) => {
                    if (registration.active) {
                        alert("Service Worker активен! Приложение работает offline.");
                    } else {
                        alert("Service Worker не активен.");
                    }
                });
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.pwa-test {
  min-height: 100vh;
  background: #1e1e1e;
  color: #fff;
  padding: 20px;
}

.pwa-test__container {
  max-width: 800px;
  margin: 0 auto;
}

.pwa-test h1 {
  font-size: 2.5rem;
  margin-bottom: 1rem;
  text-align: center;
}

.pwa-test p {
  font-size: 1.2rem;
  text-align: center;
  margin-bottom: 2rem;
  color: #ccc;
}

.pwa-test__status {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 2rem;
  border: 1px solid rgba(255, 255, 255, 0.1);
}

.pwa-test__status h2 {
  margin: 0 0 20px 0;
  font-size: 1.5rem;
}

.pwa-test__item {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 12px 0;
  border-bottom: 1px solid rgba(255, 255, 255, 0.1);

  &:last-child {
    border-bottom: none;
  }
}

.status-ok {
  color: #4CAF50;
  font-weight: 600;
}

.status-warning {
  color: #FF9800;
  font-weight: 600;
}

.status-error {
  color: #F44336;
  font-weight: 600;
}

.pwa-test__actions {
  display: flex;
  gap: 16px;
  margin-bottom: 2rem;
  flex-wrap: wrap;
}

.pwa-test__btn {
  background: #007AFF;
  color: white;
  border: none;
  border-radius: 8px;
  padding: 12px 24px;
  font-size: 16px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s ease;

  &:hover {
    background: #0056CC;
  }
}

.pwa-test__info {
  background: rgba(255, 255, 255, 0.05);
  border-radius: 12px;
  padding: 24px;
  border: 1px solid rgba(255, 255, 255, 0.1);

  h3 {
    margin: 0 0 16px 0;
    font-size: 1.2rem;
  }

  ol {
    margin: 0;
    padding-left: 20px;
    color: #ccc;
    line-height: 1.6;

    li {
      margin-bottom: 8px;
    }
  }
}

@media (max-width: 768px) {
  .pwa-test__actions {
    flex-direction: column;
  }

  .pwa-test__btn {
    width: 100%;
  }
}
</style>
